import React from "react";

export default function StatCard({ icon: Icon, label, value, accent = "#FF6B00", sub, testId }) {
    return (
        <div data-testid={testId}
            className="tactical-card corner-bracket rounded-md p-4 animate-fade-up"
            style={{ color: accent }}>
            <div className="flex items-start justify-between">
                <div>
                    <div className="label-mono text-muted-foreground">{label}</div>
                    <div className="mt-1 font-heading text-3xl font-bold text-foreground tabular-nums">{value}</div>
                    {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
                </div>
                {Icon && (
                    <div className="rounded-md p-2" style={{ background: `${accent}18` }}>
                        <Icon size={18} style={{ color: accent }} />
                    </div>
                )}
            </div>
        </div>
    );
}
